import React, { ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { InputBase, Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

import { colorPalette, screenWidthSettings } from '../constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: '100%',
    },
    searchBar: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: 'white',
      transition: '0.2s linear',
      border: '2px solid #949494',
      '&:focus-within': {
        borderColor: colorPalette.lightBlue,
      },
      '&:hover': {
        backgroundColor: 'rgba(153,153,153,0.1)',
      },
      width: '100%',
      maxWidth: screenWidthSettings.searchBarWidth,
      height: '2.5rem',
      display: 'flex',
      alignItems: 'center',
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    input: {
      color: 'inherit',
      padding: theme.spacing(1, 1, 1, 0),
      marginLeft: `calc(1em + ${theme.spacing(4)}px)`, //margin to account for search icon
      width: '100%',
      height: '100%',
    },
  })
);
interface Props {
  actionCreator: ActionCreatorWithPayload<string, string>;
  placeholder: string;
  renderLabel: boolean;
  searchQuery: string;
}

const SearchBar = ({
  actionCreator,
  placeholder,
  renderLabel,
  searchQuery,
}: Props): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    dispatch(actionCreator(e.target.value));
  };
  return (
    <div className={classes.container}>
      {renderLabel && (
        <Typography align='left' color='inherit' variant='body1'>
          Search
        </Typography>
      )}
      <div className={classes.searchBar}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <InputBase
          className={classes.input}
          placeholder={placeholder}
          type='search'
          value={searchQuery}
          onChange={handleChange}
          inputProps={{
            spellCheck: 'false',
            maxLength: '100',
          }}
        />
      </div>
    </div>
  );
};

export default SearchBar;
